<style>
.contract-tips {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.depart-choose {
  width: 300px;
  height: 30px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.place-choose {
  padding-left: 10px;
  color: #dcdfe6;
}

.place-show {
  padding-left: 10px;
}

.task-precent {
  width: 70px;
  height: 20px;
  margin: 0 10px;
}

#template-config .calc-type .el-form-item__content {
  margin-left: 15px !important;
}

.template-config .has-gutter .el-checkbox {
  display: none;
}

.btn-groups-operate {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.btn-groups-operate .btn {
  margin-left: 10px;
}
</style>
<template>
  <div class="template-config">
    <!-- 配置 -->
    <div class="back-color-fff tabel-wrap">
      <div class="btn-groups-operate">
        <el-button size="mini" type="info" v-if="!disabled" @click="chooseTemplate" class="btn">从模版选择</el-button>
        <el-button size="mini" type="danger" v-if="!disabled" @click="delTemplate" class="btn">批量删除</el-button>
      </div>
      <el-table @selection-change="handleSelectionChange2" :data="tableData" :height="tableHeight" stripe  header-cell-class-name="table_header">
        <el-table-column type="selection" v-if="!disabled" fixed="left"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- 任务名称 -->
        <el-table-column prop="taskContentName" label="项目任务名称" show-overflow-tooltip width="170" header-align="center"
          align="center" fixed="left">
          <template slot-scope="scope">
            <el-input size="mini" v-if="isPartDisabled" v-model="scope.row.taskContentName" />
            <el-input size="mini" v-else-if="!disabled" v-model="scope.row.taskContentName" />
            <span v-else>
              {{scope.row.taskContentName}}
            </span>
          </template>
        </el-table-column>
        <!-- 平台任务名称 -->
        <el-table-column prop="parentTemplateDetailName" label="平台任务名称" show-overflow-tooltip width="150"
          header-align="center" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.parentTemplateDetailName || '-' }}</span>
          </template>
        </el-table-column>
        <!-- 任务大类 -->
        <!-- <el-table-column prop="taskType" label="任务大类" show-overflow-tooltip width="150" header-align="center"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.taskType }}</span>
          </template>
        </el-table-column> -->

        <!-- 系统功能 -->
        <el-table-column prop="menuName" label="系统功能" header-align="center" width="180" align="center">
          <!-- 非问卷调查 -->
          <template slot-scope="scope">
            <div v-if="scope.row.menuUrl !== '/subFillingApp/questionnaireFilling'">
              {{ scope.row.menuName || '-' }}{{ scope.row.menuRemark ? '（' + scope.row.menuRemark + '）' : '' }}
            </div>
            <div v-else>
              <span v-if="!getSurveyName(scope.row.surveyObj)" class="txt-color"
                @click="handleChooseSurvey(scope.$index)">请选择</span>
              <span style="cursor: pointer"
                @click="handleChooseSurvey(scope.$index)">{{ getSurveyName(scope.row.surveyObj) }}</span>
            </div>
          </template>
          <!-- 问卷调查 -->
        </el-table-column>

        <!-- 业务员报价 -->
        <el-table-column show-overflow-tooltip prop="taskPrice" label="业务员报价" :render-header="renderHeader" :width="disabled ? '120': '200'" header-align="center" align="center">
          <template slot-scope="scope">
            <div style="display: flex" v-if="!disabled">
              <el-input type="input" size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30" placeholder="请输入价格"
              v-model.trim="scope.row.taskPrice"  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              </el-input>
              <el-select size="mini" v-model="scope.row.taskPriceUnitGuid"
                placeholder="单位" @change="handleSelecTaskPriceUnit(scope.row.taskPriceUnitGuid,scope.$index)">
                <el-option v-for="(item, index) in taskPriceUnitList" :key="index"
                  :label="item.paramValue" :value="item.guid"></el-option>
              </el-select>
            </div>
            <span v-else  style="word-break: keep-all;">{{ scope.row.taskPrice }} {{ scope.row.taskPriceUnit }}</span>

          </template>
        </el-table-column>


        <!-- 计算方式 -->
        <el-table-column prop="calcType" label="计算方式" show-overflow-tooltip width="150" header-align="center"
          align="center">
          <template slot-scope="scope">
            <el-select size="mini" v-if="!disabled &&scope.row.settleRule!=2" @change="calcTypeChange(scope.$index)"
              v-model="scope.row.calcType" placeholder="计算方式">
              <el-option v-for="(item, index) in calcTypeList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
            <span v-else>{{ scope.row.calcType }}</span>
          </template>
        </el-table-column>

        <!-- 任务量设置 -->
        <el-table-column prop="taskTotal" label="任务量设置" :render-header=renderHeaderIII  header-align="center" :width="disabled ? '180': '240'" align="center">
          <template slot-scope="scope">

            <div style="display: flex;justify-content:center;" v-if="!disabled">
              <el-input size="mini" type="input" style="width: 80px; float: left" oninput="value=value.replace(/[^\d]/g,'')"
                :placeholder="scope.row.calcType == '系统计算' ? '任务总量' : scope.row.calcType == '固定量人均' ? '人均任务量' : ''"
                v-model="scope.row.taskTotal" 
                v-if="scope.row.calcType == '系统计算' || scope.row.calcType == '固定量人均'">
              </el-input>

              <el-select size="mini"
                style="width: 100px; float: left; margin-left: 10px"
                v-model="scope.row.taskTotalUnitGuid"
                @change="handleSelecTaskTotalUnit(scope.row.taskTotalUnitGuid, scope.$index)" placeholder="单位">
                <el-option v-for="(item, index) in taskTotalUnitList" :key="index"
                  :label="item.paramValue + '(' + item.paramValue1 + ')'" :value="item.guid"></el-option>
              </el-select>
            </div>

            <div v-else>
              <div v-if="scope.row.calcType == '不限量'">不限量/{{scope.row.taskTotalUnit }}<span style="color:#FF991C;">({{ scope.row.countRule }})</span></div>
              <div v-else>{{ scope.row.taskTotal }} {{ scope.row.taskTotalUnit }}<span style="color:#FF991C;">({{ scope.row.countRule }})</span></div>
            </div>
          </template>
        </el-table-column>
        
   
        <el-table-column  label="操作" header-align="center" align="center" min-width="260px">
          <template slot-scope="scope">
            <a class="txt-color" v-if="!disabled && !isPartDisabled" @click="editVersion(scope.$index)">更多｜</a>
            <a class="txt-color" v-if="isPartDisabled" @click="editVersion(scope.$index)">更多</a>
            <a class="txt-color" v-if="disabled && !isPartDisabled" @click="editVersion(scope.$index)">查看</a>
            <a class="txt-color" v-if="!disabled && scope.$index != 0" @click="moveUp(scope.$index)">上移｜</a>
            <a class="txt-color" v-if="!disabled && scope.$index != tableData.length - 1" @click="moveDown(scope.$index)">下移｜</a>
            <a class="txt-color" v-if="!disabled" @click="delVersion(scope.$index)">删除</a>
          </template>
        </el-table-column>
      </el-table>
  </div>
  <!-- 弹窗 -->
  <div v-show="!iconVisible" id="template-config">
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="740px">
      <template v-if="dialogVisible">
        <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
          <div class="calc-type" style="padding-bottom:10px;">
            <el-form-item>
              <span slot="label" style="color: red">*</span>
                <span slot="label">任务结算规则</span>
                <div style="display:flex;flex-direction:column;text-align: left;">
                  <el-radio style="margin-bottom:6px;" disabled v-model="tableData[currentIndex].settleRule"
                    label="1">按单价结算，完成量*单价结算</el-radio>
                  <el-radio disabled v-model="tableData[currentIndex].settleRule" label="2">按比例结算，当任务量大于0时，按任务量的
                    <el-input :disabled="tableData[currentIndex].settleRule == 1 || isPartDisabled" class="task-precent"
                      v-model="tableData[currentIndex].settlePercent" oninput="value=value.replace(/[^\d]/g,'')" />%结算
                    <el-tooltip class="item" effect="dark"
                      content="例如：某个人发放 7 万元费用，比例配置为40%，只要有做此任务，那么结算金额最高为 2.8万元（7万 * 40%）" placement="right-start"><i
                        class="el-icon-question"></i></el-tooltip>
                  </el-radio>
                </div>
              </el-form-item>
            </div>
        
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">工作内容描述<el-tooltip class="item" effect="dark" content="手机端展示"
                  placement="right-start"><i class="el-icon-question"></i></el-tooltip>
              </span>
              <div class="fl" style="width: 400px">
    
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200"
                  placeholder="请输入" v-model="tableData[currentIndex].staffTaskNote" disabled>
                </el-input>
              </div>
            </el-form-item>
  
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">工作内容明细
                <el-tooltip class="item" effect="dark" content="手机端、PC端详细展示" placement="right-start"><i
                    class="el-icon-question"></i></el-tooltip>
              </span>
              <div class="fl" style="width: 400px">
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200"
                  placeholder="请输入" v-model="tableData[currentIndex].tenantTaskNote" disabled />
              </div>
            </el-form-item>

            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务管理要求
                <el-tooltip class="item" effect="dark" content="手机端展示给业务员看的工作要求" placement="right-start"><i
                    class="el-icon-question"></i></el-tooltip>
              </span>
              <div class="fl" style="width: 400px">
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200"
                  placeholder="请输入" v-model="tableData[currentIndex].staffWorkNote" disabled />

              </div>
            </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="medium" type="info" @click="moreSure" v-loading.fullscreen.lock="fullscreenLoading">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <div v-if="visible4">
      <el-dialog :title="sendTenantName + '问卷'" ref="multipleTable" :visible.sync="visible4" width="70%" center>
        <el-row :gutter="24" class="mb30">
          <el-col :span="13">
            <div class="search-area-div w80">问卷名称</div>
            <el-input v-model="surveyPage.surveyTitle" class="ipt-sty" placeholder="请输入"></el-input>
          </el-col>
          <el-col :span="3">
            <el-button size="medium" type="info" @click="searchSurvey()">搜索</el-button>
          </el-col>
        </el-row>
        <el-table :data="surveyList" row-key="guid" style="width: 100%" border ref="singleTable"
          @select="handleSelectSurvey" @row-click="handleClickSurvey">
          <!-- <el-table-column  header-align="center" align="center"  style="width:60px;" > 
  				     <template scope="scope">
  				      <el-radio  v-model="radio" @change.native="getCurrentRow(scope.row)" style="color: #fff;padding-left: 10px; margin-right: -25px;">{{" "}}</el-radio>
  				    </template>
          </el-table-column> -->

          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="surveyTitle" label="问卷名称" header-align="center" align="left" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="surveyDesc" label="问卷描述" header-align="center" align="left" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="subjectNum" label="题目数量" header-align="center" align="center" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChangeSurvey"
          @current-change="handleCurrentChangeSurvey" :current-page="surveyPage.pageIndex"
          :page-size="surveyPage.pageSize" layout="total, prev, pager, next, jumper" :total="surveyPage.totalRows">
        </el-pagination>
        <div slot="footer" class="dialog-footer t-right">
          <el-button plain size="medium" @click="visible4 = false">取消</el-button>
          <el-button size="medium" type="info" @click="submitFormSurvey">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import store from '@/store';
export default {
  data() {
    return {
      taskLabelListList: [],
      taskLabelVal: '',
      delFlag: false,
      serviceTenantGuid: '', //服务商id
      serviceTenantName: '', //服务商名称
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      organisationList: [],
      tenantList: [],
      taskTypeList: [],
      taskContentList: [],
      taskReqList: [],
      taskTotalUnitList: [],
      taskPriceUnitList: [],
      clientObjectList: [],
      clientObject: [],
      clientAreaRadio: '不限区域',
      clientArea: '',
      clientAreaLabel: [],
      templateName: '',
      taskType: '',
      taskContentName: '',
      tenantName: '',
      taskTag: [],
      taskTotal: '',
      taskTotalUnit: '',
      taskTotalUnitGuid: '',
      taskPrice: '',
      taskPriceUnit: '',
      taskPriceUnitGuid: '',
      taskNote: '',
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,

      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
        disabled: this.disabledTreeNode,
      },

      visible2: false,
      pageII: {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        goodsName: '',
        isPrescription: '',
        staffGuid: '',
        totalPage: 0,
        totalRows: 0,
      },
      productInformationList: [],
      multipleSelection: [],

      loading: false,
      currentIndex: 0, //当前操作行
      calcTypeList: ['固定量人均', '不限量'],
      detail: null,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      iconVisible: false,
      iconList: [],
      activeIcon: 0,
      chooseURL: null,
      waitDelTemplate: [],
      visible4: false,
      surveyObj: {},
      surveyList: [],
      surveyPage: {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        surveyState: 'Y',
        // isDraft:'Y',
        surveyTitle: '',

      }
    };
  },
  computed: {
    tableHeight() {
      return this.tableData.length > 8 ? '490px' : '';
    }
  },
  props: ['configData', 'disabled', 'sendTenantGuid', 'sendTenantName', 'isPartDisabled', 'organisationInfo', 'startTime', 'endTime'],
  created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.serviceTenantName = userInfo.tenantName;
    this.serviceTenantGuid = localStorage.guid;
    this.getTaskTotalUnitList();
    this.getTaskPriceUnitList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    configData: {
      deep: true,
      handler(val) {
        this.getDetail(val);
      },
    },
    sendTenantGuid(newVal, oldVal) {
      if (newVal != oldVal && oldVal) {
        var tableData = this.tableData;
        tableData.forEach(item => {
          item.multipleSelection = []
        })
        this.tableData = tableData;
      }
    },
  },
  methods: {
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'light',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '药企端查看的任务价格单位，仅供展示'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    renderHeaderII: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'light',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '移动端业务员查看的任务价格单位，仅供展示'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    renderHeaderIII: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '说明: 用于配置任务执行后统计的规则',
                h('br'),
                '比如【拜访医生任务】，单位如下说明：',
                h('br'),
                '1、按人（去重）：一个月拜访两次张三，按拜访 1 人统计，实际结算 500元；',
                h('br'),
                ' 2、按人次（不去重）：一个月拜访两次张三，按实际拜访 2 人 统计，实际结算1000元。',
                h('br'),
                ' 3、按次：提交一条拜访记录则算 1 次，实际结算 500元；',
                h('br'),
                ' 比如【优位陈列任务】，单位如下说明：',
                h('br'),
                '1、按家：一个月拜访 2 家同样的医院，按完成 1 家统计，实际结算 500元；',
                h('br'),
                '2、按家次：目前应用于【万年青】，比如要求拜访某一家药店，必须要每周完成3次拜访，完成后，按 500 元结算。',
                h('br'),
                ' 3、按次：提交一条拜访记录则算 1 次，如果一个月提交 2 次，实际结算 1000元；'
              ]
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    handleProvinceAndCity() {
      this.$nextTick(() => {
        let arr = this.$refs['cascaderAddr'].getCheckedNodes()
        let newList = [];
        arr.forEach(item => {
          if (item.level == 1 && item.label == '北京市' || item.level == 1 && item.label == '上海市' || item.level == 1 && item.label == '重庆市' || item.level == 1 && item.label == '天津市') {
            newList.push(item.label)
          } else if (item.level == 2 && item.label != '市辖区' && item.label != '县') {
            newList.push(item.label)
          }
        })
        this.tableData[this.currentIndex].clientAreaLabel = newList

      })
    },
    getSurveyName(obj) {
      if (!obj) return;
      return obj.surveyTitle;
    },
    calcTypeChange(index) {
      this.tableData[index].taskTotal = null;
      if (this.tableData[index].calcType == '不限量') {
        this.tableData[index].isOpenMaxTask = false;
        this.tableData[index].maxTaskValue = 0;
      }
    },
    chooseTemplate() {
      this.$emit('openTemplate');
    },
    seeForecast() {
      this.$emit('seeForecast');
    },
    handleSelectionChange2(v, j) {
      this.waitDelTemplate = v;
    },
    //批量删除模版
    delTemplate() {
      if (this.waitDelTemplate.length == 0) {
        this.$message.error('请选择待删除的任务模版');
        return;
      }
      let guids = [];
      this.waitDelTemplate.forEach(item => {
        guids.push(item.guid);
      })
      this.$emit('delList', guids);
      this.waitDelTemplate.forEach((i, j) => {
        this.tableData.forEach((k, l) => {
          if (i === k) {
            this.tableData.splice(l, 1);
          }
        });
      });
      this.delFlag = true;
    },
    //设置执行规则
    setRule() {
      this.$emit('setRule');
    },
    handleSelecTaskPriceUnit(value,index) {
      let taskPriceUnitList = this.taskPriceUnitList;
      let labelItem = taskPriceUnitList.filter(item => item.guid == value)
      this.tableData[index].taskPriceUnitGuid = value;
      this.tableData[index].taskPriceUnit = labelItem[0].paramValue;
      this.tableData[index].tenantTaskPriceUnitGuid = value;
      this.tableData[index].tenantTaskPriceUnit = labelItem[0].paramValue;
    },
    handleSelecTaskTotalUnit(value, index) {
      let taskTotalUnitList = this.taskTotalUnitList;
      let labelItem = taskTotalUnitList.filter(item => item.guid == value)
      console.log(labelItem)
      this.tableData[index].taskTotalUnit = labelItem[0].paramValue;
    },
    moveDown(index) {
      var tableData = JSON.parse(JSON.stringify(this.tableData));
      var temp = tableData[index];
      var temp_1 = tableData[index + 1];
      tableData[index] = temp_1;
      tableData[index + 1] = temp;
      this.tableData = tableData;
      this.$forceUpdate();
    },
    moveUp(index) {
      var tableData = JSON.parse(JSON.stringify(this.tableData));
      var temp = tableData[index];
      var temp_1 = tableData[index - 1];
      tableData[index] = temp_1;
      tableData[index - 1] = temp;
      this.tableData = tableData;
      this.$forceUpdate();
    },
    taskTagChange() {
      var index = this.currentIndex;
      var taskTagList = this.tableData[index].taskTag;
      var taskReqList = this.tableData[index].taskReqList;
      var list = [];
      var resultArr = [];
      taskTagList.forEach((el) => {
        taskReqList.forEach((item) => {
          if (el == item.paramName) {
            list.push(item.paramValue);
          }
        });
      });
      this.tableData[index].staffWorkNote = list.join('\n');
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    searchData() {
      this.getData();
    },
    moreSure() {
      var index = this.currentIndex;
      var tableData = this.tableData;
      if (tableData[index].settleRule == 2 && !tableData[index].settlePercent) {
        this.$message.error('请输入结算比例');
        return;
      }
      if (!tableData[index].tenantTaskNote) {
        this.$message.error('请填写药企任务文案');
        return;
      }
      if (!tableData[index].staffTaskNote) {
        this.$message.error('请填写业务员任务文案');
        return;
      }
      if (tableData[index].fileList.length == 0) {
        this.$message.error('请上传任务图标');
        return;
      }
      this.dialogVisible = false;
    },
    handleChooseGoods(index) {
      if (this.disabled) return;
      if (!this.sendTenantGuid) {
        this.$message.error('请选择委托方');
        return;
      }
      this.visible2 = true;
      this.currentIndex = index;
      this.getData();
    },
    handleChooseSurvey(index) {
      if (this.disabled) return;
      if (!this.sendTenantGuid) {
        this.$message.error('请选择委托方');
        return;
      }
      this.visible4 = true;
      this.currentIndex = index;
      this.getSurvey();
    },
    searchSurvey() {
      this.pageIndex = 1,
        this.pageSize = 10,
        this.getSurvey();
    },
    //单选实现
    handleSelectSurvey(selection, row) {
      this.$refs.singleTable.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.surveyObj = {
          surveyTitle: row.surveyTitle,
          surveyTenantGuid: row.guid
        };
        this.$refs.singleTable.toggleRowSelection(row, true);
      }
    },
    handleClickSurvey(row, col, event) {
      this.$refs.singleTable.clearSelection();
      row.flag = !row.flag;
      this.$refs.singleTable.toggleRowSelection(row, row.flag);
      this.surveyObj = {
        surveyTitle: row.surveyTitle,
        surveyTenantGuid: row.guid
      }


      // this.templateSelectd = row;
    },
    submitFormSurvey() {
      if (!this.surveyObj.surveyTenantGuid) {
        this.$message.error('请先选择一个问卷');
        return
      }
      // console.log(this.tableData)
      // console.log(this.currentIndex)
      this.tableData[this.currentIndex].surveyObj = this.surveyObj;
      console.log(this.tableData)
      this.visible4 = false;
    },
    getGoodsName(list) {
      var strList = [];
      list.forEach((item) => {
        strList.push(item.goodsName);
      });
      return strList.join('、');
    },
    submitForm() {
      this.visible2 = false;
    },
    getDetail(detailList) {
      if (this.delFlag) {
        this.delFlag = false;
        return;
      }
      console.log(detailList)
      var self = this;
      this.tableData = [];
      detailList.forEach((el, ky) => {
        var tableItem = {
          departmentData: [], //部门
          taskType: '', //任务大类
          taskTypeGuid: '',//任务大类Guid
          taskContentName: '', //任务名称
          taskContentList: [], //任务名称list
          taskContentGuid: '',
          menuUrl: '', // 系统功能路径
          menuName: '', //系统功能
          taskContentJson: '',
          isAllowTenantUse: '',
          taskPrice: '', //任务价格
          taskPriceUnit: '',
          taskPriceUnitGuid: '',

          taskTotal: '',
          taskTotalUnit: '',
          taskTotalUnitGuid: '',

          tenantTaskPrice: '', //药企报价
          tenantTaskPriceUnit: '',
          tenantTaskPriceUnitGuid: '',

          settleRule: "1", //1单价 2比例

          contractTaskType: 0,// 0=正常 1=该任务未签署合同 2=该任务在当前企业合同中未签约，请尽快签署补充协议变更合同任务
          contractTaskPrice: '',//合同价格

          taskCode:'',//任务编码
          goodsCategoryJson:[],//产品分类
          marketingCategoryJson:[],//市场分类
          staffCategoryJson:[],//分类对象
          taskMediumType:'',//任务中类
          isNormalTask:'',//是否常规任务

          isAskClock: '', //是否要求打卡 是/否

          isAskPhoto: '', //是否要求拍照 是/否
          minAskPhoto: '', //最少要求拍照数量

          isAskUpload: '', //是否要求上传资料 是/否
          minAskUpload: '', //最少上传资料数量

          isOpenMaxTask: 'Y', //是否开启超量上限拦截
          maxTaskValue: 0,  // 超量限制

          taskTag: '', //任务要求
          multipleSelection: [], //品种
          calcType: '',
          tenantWorkNote: '', //药企工作要求
          tenantTaskNote: '', //药企任务文案
          staffWorkNote: '', //运营工作要求
          staffTaskNote: '', //运营任务文案
          taskLabel: '',
          clientAreaRadio: '不限区域',
          clientAreaLabel: [],
          clientArea: [],
          clientObject: '',
          fileList: [],
          guid: el.guid,
          isTeamLeader: '',
          surveyObj: null,
          parentTemplateDetailName: '',
          parentTemplateDetailGuid: '',
          countRule:''

        };
        tableItem.countRule = el.countRule;
        //根名
        tableItem.parentTemplateDetailName = el.parentTemplateDetailName;
        tableItem.parentTemplateDetailGuid = el.parentTemplateDetailGuid;

        //任务大类
        tableItem.taskType = el.taskType;
        tableItem.taskTypeGuid = el.taskTypeGuid;
        self.getTaskContentList(el.taskType, ky);
        self.getTaskReqList(el.taskContentGuid, ky);

        //任务名称
        tableItem.taskContentName = el.taskContentName;
        tableItem.taskContentGuid = el.taskContentGuid;
        tableItem.menuUrl = el.menuUrl;
        tableItem.menuName = el.menuName;
        tableItem.menuRemark = el.menuRemark;
        tableItem.taskContentJson = el.taskContentJson;
        tableItem.isTeamLeader = el.isTeamLeader;
        tableItem.isAllowTenantUse = el.isAllowTenantUse;
        tableItem.taskContentType = el.taskContentType;
        tableItem.clientObject = el.clientObject;
        
        //任务编码
        tableItem.taskCode = el.taskCode;
        //产品分类
        tableItem.goodsCategoryJson = el.goodsCategoryJson;
        //市场分类
        tableItem.marketingCategoryJson = el.marketingCategoryJson;

        tableItem.staffCategoryJson = el.staffCategoryJson;
        //任务中类
        tableItem.taskMediumType = el.taskMediumType;
        //是否常规任务
        tableItem.isNormalTask = el.isNormalTask;
       
       

        //药企价格
        tableItem.tenantTaskPrice = el.tenantTaskPrice;
        tableItem.tenantTaskPriceUnit = el.tenantTaskPriceUnit.replace(' ', '');
        tableItem.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;

        //业务员报价
        tableItem.taskPrice = el.taskPrice;
        tableItem.taskPriceUnit = el.taskPriceUnit.replace(' ', '');
        tableItem.taskPriceUnitGuid = el.taskPriceUnitGuid;

        tableItem.settleRule = el.settleRule; //1单价 2比例
        tableItem.settlePercent = el.settlePercent; //1单价 2比例

        //是否要求打卡
        tableItem.isAskClock = el.isAskClock;

        //是否要求拍照
        tableItem.isAskPhoto = el.isAskPhoto;

        //最少要求拍照数量
        tableItem.minAskPhoto = el.minAskPhoto;

        //是否要求上传资料
        tableItem.isAskUpload = el.isAskUpload;

        //最少上传资料数量
        tableItem.minAskUpload = el.minAskUpload;


        tableItem.isOpenMaxTask = el.isOpenMaxTask || 'Y';
        tableItem.maxTaskValue = el.maxTaskValue || 0;

        //任务量设置
        tableItem.taskTotal = el.taskTotal;
        tableItem.taskTotalUnit = el.taskTotalUnit;
        tableItem.taskTotalUnitGuid = el.taskTotalUnitGuid;
        //商品
        var multipleSelection = [];
        var goodsInfo = el.goodsInfo ? JSON.parse(el.goodsInfo) : [];
        if (goodsInfo.length != 0) {
          goodsInfo.forEach((i) => {
            multipleSelection.push({
              guid: i.guid,
              goodsName: i.name,
              unitStyle: i.goodsUnit,
              goodsSpec: i.goodsSpec,
            });
          });
        }
        tableItem.multipleSelection = multipleSelection;
        //客户区域
        if (!Array.isArray(el.clientArea)) {
          var clientArea = el.clientArea ? JSON.parse(el.clientArea) : [];
          console.log(clientArea)
          clientArea.forEach((item) => {
            if (item.name == '本区域' || item.name == '不限区域') {
              tableItem.clientAreaRadio = item.name;
            } else {
              tableItem.clientAreaRadio = '指定区域';
              tableItem.clientArea.push([item.provinceCode, item.guid]);
              if (item.name) {
                tableItem.clientAreaLabel.push(item.name);
              }

            }
          });
        } else {
          var clientArea = el.clientArea
          console.log(clientArea)
          clientArea.forEach((item) => {
            if (item.name == '本区域' || item.name == '不限区域') {
              tableItem.clientAreaRadio = item.name;
            } else {
              tableItem.clientAreaRadio = '指定区域';
              tableItem.clientArea.push([item.provinceCode, item.guid]);
              if (item.name) {
                tableItem.clientAreaLabel.push(item.name);
              }
            }
          });
        }
        //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
        if (el.staffWorkNote.indexOf('[') > -1) {
          tableItem.staffWorkNote = JSON.parse(el.staffWorkNote);
          tableItem.staffWorkNote = tableItem.staffWorkNote.join('\n')
        } else {
          tableItem.staffWorkNote = el.staffWorkNote
        }

        tableItem.staffTaskNote = el.staffTaskNote;
        tableItem.tenantWorkNote = el.tenantWorkNote;
        tableItem.tenantTaskNote = el.tenantTaskNote;


        tableItem.surveyObj = el.surveyObj;

        //图标
        tableItem.fileList = el.taskIcon ? JSON.parse(el.taskIcon) : el.fileList;

        //任务要求
        tableItem.taskTag = !Array.isArray(el.taskTag) ? JSON.parse(el.taskTag) : el.taskTag;
        //标签
        tableItem.taskLabel = !Array.isArray(el.taskLabel) ? JSON.parse(el.taskLabel) : el.taskLabel;
        //是否在合同里
        tableItem.contractTaskType = el.contractTaskType;
        //合同价格
        tableItem.contractTaskPrice = el.contractTaskPrice;
        //任务编码
        tableItem.taskCode = el.taskCode;
        //产品分类
        tableItem.goodsCategoryJson = el.goodsCategoryJson;
        //市场分类
        tableItem.marketingCategoryJson = el.marketingCategoryJson;

        tableItem.staffCategoryJson = el.staffCategoryJson;
        //任务中类
        tableItem.taskMediumType = el.taskMediumType;
        //是否常规任务
        tableItem.isNormalTask = el.isNormalTask;



        if(el.settleRule == 2){ 
          //任务结算方式为按比例结算 计算方式为不限量
          tableItem.calcType = '不限量';
          tableItem.isOpenMaxTask = 'N';
        }else{
           //计算方式
          tableItem.calcType = el.taskTotalType || el.calcType;
        }
    

        // tableItem.taskLabel = el.taskLabel?JSON.parse(el.taskLabel):[];

        self.tableData.push(tableItem);

      });
      console.log( self.tableData)
    },
    //选择部门
    handleChooseDepart() {
      this.visible3 = true;
    },

    getDeliverName(res) {
      var list = res;
      var strList = [];
      if (list.length == 0) return;
      list.forEach((item) => {
        strList.push(item.organisationName);
      });
      return strList.join('、');
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: this.$getValueListByKey('上游客户分类'),
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
          self.handleSelectFactory();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskContentList(taskType, currentIndex) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        taskType: taskType,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData[currentIndex].taskContentList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskReqList(paramValue1, currentIndex) {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '工作要求',
        tenantGuid: localStorage.guid,
        paramValue1: paramValue1,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData[currentIndex].taskReqList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskTotalUnitList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务单位',
        paramName: '任务总量单位', //单位类型
        // tenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskTotalUnitList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskPriceUnitList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务单位',
        paramName: '任务价格单位', //单位类型
        // tenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskPriceUnitList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectTaskType(taskType, currentIndex) {
      this.tableData[currentIndex].taskContentName = '';
      this.getTaskContentList(taskType, currentIndex);
    },
    handleSelectContentName(row, currentIndex) {
      var taskContentList = row.taskContentList;
      var taskContentName = row.taskContentName;
      taskContentList.forEach((item) => {
        if (item.taskContentName == taskContentName) {
          this.tableData[currentIndex].menuName = item.menuName;
          this.tableData[currentIndex].menuUrl = item.menuUrl;
          this.tableData[currentIndex].taskContentJson = item.taskContentJson;
          this.tableData[currentIndex].isAllowTenantUse = item.isAllowTenantUse;
        }
      });
    },
    handleSelectFactory() {
      var tenantList = this.tenantList;
      var tableData = this.tableData;
      tenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          this.getData();
          this.getOrganisation(item.guid);
          tableData.forEach((item) => {
            // item.departmentData = [];
            // item.multipleSelection = [];
          });
          this.tableData = tableData;
        }
      });
    },
    delVersion(index) {
      this.tableData.splice(index, 1);
      this.$emit('delItem', index);
      this.delFlag = true;
    },
    editVersion(index) {
      this.textTitle = this.tableData[index].taskContentName
        ? `【${this.tableData[index].taskContentName}】编辑`
        : '任务名称编辑';
      this.dialogVisible = true;
      this.currentIndex = index;
      // var taskTagList = this.tableData[index].taskTag;
      // var taskReqList = this.taskReqList;
      // var list = [];
      // taskTagList.forEach((el) => {
      //   taskReqList.forEach((item) => {
      //     if (el == item.paramName) {
      //       // list.push(item.paramName + '(' + item.paramValue + ')');
      //       list.push(item.paramValue);
      //     }
      //   });
      // });
      //this.tableData[index].staffWorkNote = list.join('\n');
    },
    //获取组织
    getOrganisation(guid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=` + guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
            self.tableData = [];
          }
        });
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    //部门弹框选择
    handleNodeClick1(data) {
      this.departmentList = this.$refs.tree.getCheckedNodes(false);
      this.$forceUpdate();
    },
    //确定选择部门
    departmentSure() {
      if (this.departmentList.length == 0) {
        this.$message.error('请勾选部门！');
        return;
      }
      this.visible3 = false;
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    //删除单个部门
    delDepartmentSingle(index) {
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);
      // this.departmentList.splice(index,1)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    //获取产品数据
    getData() {
      let self = this;
      let tenantGuid = this.sendTenantGuid
      self.pageII.tenantGuid = tenantGuid;

      self.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, self.pageII).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.productInformationList = res.data.data.records;
          self.pageII.totalPage = res.data.data.totalPages;
          self.pageII.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSurvey() {
      let self = this;
      let tenantGuid = this.sendTenantGuid
      self.surveyPage.tenantGuid = tenantGuid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/list`, self.surveyPage).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.surveyList = res.data.data.records;
          self.surveyPage.totalPage = res.data.data.totalPages;
          self.surveyPage.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChangeSurvey(val) {
      let self = this;
      self.surveyPage.pageSize = val;
      this.getData();
    },
    handleCurrentChangeSurvey(val) {
      let self = this;
      self.surveyPage.pageIndex = val;
      this.getSurvey();
    },
    handleSizeChange1(val) {
      let self = this;
      self.pageII.pageSize = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.pageII.pageIndex = val;
      this.getData();
    },
    handleSelectionChange(val) {
      let self = this;
      self.tableData[this.currentIndex].multipleSelection = val;
    },
    btn(row, col, event) {
      row.flag = !row.flag;
      this.$refs.dataTable.toggleRowSelection(row, row.flag);
    }

  },
};
</script> 
<style scoped>
#template-config /deep/ .el-dialog {
  /* height: 80vh; */
  overflow: auto;
}

/* .el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
} */

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

.content {
  background: #fff;
  font-size: 18px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}

.base-content {
  display: flex;
  font-size: 15px;
  padding: 20px 0;
}

.base-content .base-info {
  display: flex;
  align-items: center;
  padding: 0 40px;
}

.base-content .base-info .base-title {
  word-break: keep-all;
}

.button-area {
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
  margin-top: 0;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 130px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 150px;
}

.img-close {
  position: relative;
  float: left;
  width: 150px;
  height: 150px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
}

/* /deep/ .el-table td {
  padding: 5px 0px;
} */
/deep/ .el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  height: 33px;
}

/deep/ .el-cascader__tags {
  display: inline-flex;
  flex-wrap: nowrap;
  overflow: hidden;
}

.tabel-wrap {
  padding: 0px 20px 10px 20px;
}</style>
<style >.icon-dialog-wrap .el-dialog__body {
  padding: 0;
  padding-top: 10px;
}

#template-config .el-form-item__content {
  margin-left: 15px !important;
}

#template-config .el-form-item {
  align-items: flex-start;
}

#template-config .calc-type .el-form-item__label {
  line-height: 15px;
}</style>